module.exports = __webpack_public_path__ + "static/media/Adult_nav.ca1513e3.svg";